import type { HmiBindingSource } from "../schema/hmi-bindings.schema";

export function sourceFingerprint(source: HmiBindingSource): string {
  if (source.kind === "static") {
    return `static:${JSON.stringify(source.value)}`;
  }
  return [
    source.kind,
    source.deviceId,
    source.channel ?? "",
    source.formula ?? "",
    source.metricId ?? "",
    source.readMode ?? "live",
    source.timeRange,
    source.aggregation,
  ].join("|");
}

function hashToHex(seed: string): string {
  let h1 = 0x811c9dc5;
  let h2 = 0x9e3779b9;
  for (let index = 0; index < seed.length; index += 1) {
    const code = seed.charCodeAt(index);
    h1 ^= code;
    h1 = Math.imul(h1, 0x01000193);
    h2 ^= code;
    h2 = Math.imul(h2, 0x85ebca6b);
  }
  const part1 = (h1 >>> 0).toString(16).padStart(8, "0");
  const part2 = (h2 >>> 0).toString(16).padStart(8, "0");
  const part3 = ((h1 ^ h2) >>> 0).toString(16).padStart(8, "0");
  const part4 = ((h1 + h2) >>> 0).toString(16).padStart(8, "0");
  return `${part1}${part2}${part3}${part4}`;
}

export function sourceQueryId(source: HmiBindingSource): string {
  const hex = hashToHex(sourceFingerprint(source));
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
}
